import buildActiveSharesArr from "./build_active_shares_arr";
import buildHistoryTransactionObj from "./build_history_transaction_obj";

export const createInvestTransArrays = (
  transactions,
  currentPriceArr,
  beginHistoryTransNbr
) => {
  const buyQueues = {};
  const historyArr = [];
  transactions.sort((a, b) => (+a.transNbr > +b.transNbr ? 1 : -1));

  // Copy of the original transactions that we'll subtract from
  const unmatchedTransactions = transactions.map(tx => ({ ...tx }));
  let historyTransNbr = beginHistoryTransNbr;

  for (const tx of transactions) {
    const {
      investShortName,
      tranType,
      quantity,
      unitPrice,
      transNbr,
      transactionDate
    } = tx;

    const qty = parseFloat(quantity);
    const price = parseFloat(unitPrice);
 
    if (!buyQueues[investShortName]) {
      buyQueues[investShortName] = [];
    }

    switch (tranType) {
      case "buy": {
        const buyTxWrapper = {
          transactionRef: tx,
          originalQty: qty,
          remainingQty: qty,
          matchedSales: []
        };
        buyQueues[investShortName].push(buyTxWrapper);
        break;
      }

      case "sell":
      case "redemption": {
        let remainingSellQty = qty;

        while (remainingSellQty > 0 && buyQueues[investShortName].length > 0) {
          const buyTx = buyQueues[investShortName][0];
          const matchQty = Math.min(buyTx.remainingQty, remainingSellQty);
          const gainLoss = (price - parseFloat(buyTx.transactionRef.unitPrice)) * matchQty;

          // Create history transaction for this matched portion
          const historyTranType = "buy-" + tranType;
          const buyAmount = +buyTx.transactionRef.unitPrice * matchQty;
          const sellAmount = +price * matchQty;
          const buyPrice = +buyTx.transactionRef.unitPrice;
          historyTransNbr += 1;
          const tranInfo = {
            investShortName: investShortName,
            tranType: historyTranType,
            quantity: matchQty,
            dateBought: buyTx.transactionRef.transactionDate,
            dateClosed: transactionDate,
            buyPrice: buyPrice.toFixed(2),
            buyAmount: buyAmount.toFixed(2),
            sellPrice: price.toFixed(2),
            sellAmount: sellAmount.toFixed(2),
            totalGainLoss: gainLoss.toFixed(2),
            transNbr: historyTransNbr
          };

          const historyTranObj = buildHistoryTransactionObj(tranInfo);
          historyArr.push(historyTranObj);

          // Update quantities
          buyTx.remainingQty -= matchQty;
          remainingSellQty -= matchQty;

          // Modify unmatched buy transaction
          const buyIndex = unmatchedTransactions.findIndex(
            t => t.transNbr === buyTx.transactionRef.transNbr
          );

          if (buyIndex !== -1) {
            if (buyTx.remainingQty > 0) {
              // Partial sale: update quantity
              unmatchedTransactions[buyIndex].quantity = buyTx.remainingQty.toFixed(2);
            } else {
              // Fully sold: remove from unmatched and queue
              unmatchedTransactions.splice(buyIndex, 1);
              buyQueues[investShortName].shift();
            }
          }

          if (remainingSellQty === 0) {
            const sellIndex = unmatchedTransactions.findIndex(
              t => t.transNbr === tx.transNbr
            );
            if (sellIndex !== -1) unmatchedTransactions.splice(sellIndex, 1);
          }
        }

        break;
      }

      case "coupon": {
        const totalCouponAmt = (qty * price).toFixed(2);
        historyTransNbr += 1;

        const tranInfo = {
          investShortName: investShortName,
          tranType: tranType,
          quantity: qty,
          dateBought: transactionDate,
          dateClosed: transactionDate,
          sellPrice: price.toFixed(2),
          sellAmount: totalCouponAmt,
          totalGainLoss: totalCouponAmt,
          transNbr: historyTransNbr
        };

        const historyTranObj = buildHistoryTransactionObj(tranInfo);
        historyArr.push(historyTranObj);

        // Remove coupon from unmatched
        const couponIndex = unmatchedTransactions.findIndex(
          t => t.transNbr === transNbr
        );
        if (couponIndex !== -1) unmatchedTransactions.splice(couponIndex, 1);
        break;
      }
    default: 
      break;
    }
  }

  const openTransactionsArr = unmatchedTransactions;
  const activeSharesArr = buildActiveSharesArr(buyQueues, currentPriceArr);

  return {
    openTransactions: openTransactionsArr,
    history: historyArr,
    activeShares: activeSharesArr
  };
};

export default createInvestTransArrays;
